/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * The rules that lost their condition and so became unconditional.
 * 
 * Returned so the caller can say which rules now always match, rather than leaving that to be
 * discovered from behaviour.
 * @export
 * @interface ConditionDetachResponse
 */
export interface ConditionDetachResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof ConditionDetachResponse
     */
    detachedRuleIds: Array<string>;
}

/**
 * Check if a given object implements the ConditionDetachResponse interface.
 */
export function instanceOfConditionDetachResponse(value: object): value is ConditionDetachResponse {
    if ((!('detachedRuleIds' in (value as Record<string, any>)) && !('detached_rule_ids' in (value as Record<string, any>))) || ((value as Record<string, any>)['detachedRuleIds'] === undefined && (value as Record<string, any>)['detached_rule_ids'] === undefined)) return false;
    return true;
}

export function ConditionDetachResponseFromJSON(json: any): ConditionDetachResponse {
    return ConditionDetachResponseFromJSONTyped(json, false);
}

export function ConditionDetachResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConditionDetachResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'detachedRuleIds': json['detached_rule_ids'],
    };
}

export function ConditionDetachResponseToJSON(json: any): ConditionDetachResponse {
    return ConditionDetachResponseToJSONTyped(json, false);
}

export function ConditionDetachResponseToJSONTyped(value?: ConditionDetachResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'detached_rule_ids': value['detachedRuleIds'],
    };
}

